<template>
  <div class="onlineRefund">
    <div class="onlineRefund-content">
        <div class="onlineRefund-item">
            <div class="onlineRefund-line">
                <div>预交金余额</div>
                <div>¥{{ prepaidBalance }}</div>
            </div>
            <div class="onlineRefund-line">
                <div>可退金额</div>
                <div>¥{{ refundableAmount }}</div>
            </div>
        </div>
        <div class="onlineRefund-i">
            <span>{{ patientName  }}</span>
            <div>{{ hisCardNo }}</div>
            <!-- <div>{{ hisCardNo ? hisCardNo.substring(0,2) + '******' + hisCardNo.substring(hisCardNo.length-2) : '00******55' }}</div> -->
        </div>
    </div>
    <div class="onlineRefund-info">
      <div class="onlineRefund-info-title">请填写卡片信息</div>
      <div class="onlineRefund-info-user">
        <van-field
          v-model="patientName"
          label-class="label-title"
          label="姓名"
          placeholder="请输入卡片的真实姓名"
          disabled
        />
        <van-field
          v-model="idCard"
          label-class="label-title"
          label="身份证号"
          placeholder="请输入卡片的身份证"
          disabled
        />
        <van-field
          v-model="phone"
          type="number"
          label-class="label-title"
          label="电话"
          placeholder="请输入卡片的联系电话"
          disabled
        />
        <!-- 移除验证码输入框 -->
      </div>
    </div>
    <div class="onlineRefund-info">
      <div class="onlineRefund-info-title">请选择退款路径</div>
      <div class="onlineRefund-info-user">
        <van-radio-group v-model="appointmentType">
            <van-cell-group>
                <van-cell clickable @click="appointmentType = '1'">
                    <img style="width: 1rem;margin-right: 1rem;vertical-align: text-bottom;" :src="require('@assets/WeChat.png')" alt="" />
                    <span style="font-size: .9rem;">退款至 微信零钱</span>
                    <van-radio slot="right-icon" name="1" />
                </van-cell>
                <van-cell clickable @click="appointmentType = '2'">
                    <img style="width: 1rem;margin-right: 1rem;vertical-align: text-bottom;" :src="require('@assets/alipy.png')" alt="" />
                    <span style="font-size: .9rem;">退款至 支付宝余额</span>
                    <van-radio slot="right-icon" name="2" />
                </van-cell>
            </van-cell-group>
        </van-radio-group>
      </div>
    </div>
    <div class="onlineRefund-info">
      <div class="onlineRefund-info-title">请填写退款信息</div>
      <div class="onlineRefund-info-user">
        <van-field
            v-model="refundAmount"
            type="number"
            label-class="label-title"
            label="退款金额"
            placeholder="请输入退款金额"
        >
            <div style="font-size: .9rem;color: #108eee;" slot="right-icon" @click="setFullRefund">全额退款</div>
        </van-field>
        <van-field
            v-model="accountName"
            label-class="label-title"
            label="收款账户姓名"
            :placeholder="appointmentType == '1' ?'请输入微信实名认证姓名' : '请输入支付宝实名认证姓名'"
        />
        <van-field
            v-if="appointmentType == '2'"
            v-model="aliPayAccount"
            label-class="label-title"
            label="支付宝账号"
            placeholder="请输入支付宝账号"
            class="alipy-message"
            error-message="支付宝账号为注册时的邮箱或手机号"
        />
        <van-field
            v-model="phone"
            type="number"
            label-class="label-title"
            label="退款通知电话"
            placeholder="用于通知退款结果"
        />
      </div>
    </div>
    <div class="onlineRefund-info-submit">
      <van-button 
        type="primary" 
        size="large" 
        round 
        block 
        :loading="submitting"
        loading-text="提交中..."
        @click="submitDemo"
        class="submit-button"
      >
        提交退款申请
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineRefundNoVerify',
  data() {
    return {
      // 展示信息（可根据需要手动填写或保持空）
      patientName: '',
      idCard: '',
      hisCardNo: '',
      phone: '',

      // 退款选择与金额
      appointmentType: '1', // 1=微信零钱，2=支付宝余额
      refundAmount: '',
      accountName: '',
      aliPayAccount: '',
      prepaidBalance: 0, // 预交金余额
      refundableAmount: 0, // 可退金额
      submitting: false,
    };
  },
  created() {
    this.getBaseInfo()
  },
  methods: {
    getBaseInfo() {
      this.$http
      .post(this.$api.REFUNDPATIENT_BASEINFO, { patientCard:this.$route.query.hisCardNo })
      .then(res => {
        this.prepaidBalance = res.prepay
        this.refundableAmount = res.prepay
        this.patientName = res.patientName
        this.hisCardNo = res.cardNo
        this.idCard = res.idCard
        this.phone = res.linkTel
      })
    },
    setFullRefund() {
      this.refundAmount = this.refundableAmount || '';
    },
    submitDemo() {
      // 纯页面版本：不接入后端接口，仅做演示提示
      if (!this.patientName || !this.idCard || !this.hisCardNo) {
        this.$toast && this.$toast('请完善患者信息');
        return;
      }
      if (!this.refundAmount) {
        this.$toast && this.$toast('请输入退款金额');
        return;
      }
      const channel = this.appointmentType === '1' ? '微信零钱' : '支付宝余额';
      this.$dialog && this.$dialog.alert({
        message: `演示版：将通过${channel}退款。实际接口逻辑暂未接入。`,
      });
    },
  },
};
</script>
<style lang="less">
.onlineRefund {
  min-height: 100vh;
  padding: 0.5rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  box-sizing: border-box;

  &-content {
    padding: 1rem;
    color: white;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 1rem;
    font-size: 1.21rem;
    box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
    margin-bottom: 1rem;
    
    span {
      font-size: 0.88rem;
    }
  }
  
  &-item {
    opacity: 0.9;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  
  &-line {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    div:first-child {
      font-size: 0.9rem;
      opacity: 0.8;
      margin-bottom: 0.3rem;
    }
    
    div:last-child {
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
  
  &-i {
    display: flex;
    opacity: 0.8;
    font-size: 0.9rem;
    margin-top: 1rem;
    
    span {
      margin-right: 1rem;
    }
  }

  &-info {
    margin: 1rem 0;
    padding: 1rem;
    background: white;
    border-radius: 1rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(102, 126, 234, 0.1);
    
    &-title {
      margin-bottom: 0.8rem;
      font-weight: 600;
      font-size: 1.1rem;
      color: #333;
      position: relative;
      padding-left: 0.8rem;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 1.2rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 2px;
      }
    }

    &-type {
      display: flex;
      justify-content: space-around;
      padding: 0.3rem 20%;
    }

    .van-cell {
      padding: 0.8rem 0;
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      transition: all 0.3s ease;
      
      &:hover {
        background-color: #f8f9ff;
      }
    }
    
    .van-cell::after {
      border-color: rgba(102, 126, 234, 0.1);
    }
    
    .van-field {
      border-radius: 0.5rem;
      margin-bottom: 0.5rem;
      
      &__control {
        font-size: 1rem;
        color: #333;
      }
      
      &__label {
        color: #555;
        font-weight: 500;
      }
      
      &__control:disabled {
        color: #999;
      }
    }
    
    .label-title {
      font-size: 1rem;
      color: #555;
    }

    &-user {
      border-bottom: 1px solid rgba(102, 126, 234, 0.1);
    }

    &-tips {
      padding: 1rem 0;
      font-size: 1rem;
      
      h4 {
        margin: 0;
        color: #333;
      }
      
      span {
        color: #666;
        font-size: 0.9rem;
      }
    }
    
    &-submit {
      margin: 1.5rem 0 0.5rem;
      padding: 0 1rem;
      
      .submit-button {
        height: 3rem;
        font-size: 1.1rem;
        font-weight: 600;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        transition: all 0.3s ease;
        
        &:active {
          transform: translateY(1px);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }
        
        &.van-button--loading {
          background: linear-gradient(135deg, #a8a8a8 0%, #999 100%);
        }
      }
    }
  }
  
  .alipy-message .van-field__error-message {
    color: #ff6b6b;
    font-weight: 500;
    font-size: 0.85rem;
  }
  
  // 验证码按钮样式
  .verification-code-btn {
    font-size: 0.9rem;
    color: #667eea;
    font-weight: 600;
    padding: 0.4rem 1rem;
    border-radius: 1.2rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border: 1px solid rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
    cursor: pointer;
    user-select: none;
    
    &:hover {
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
      border-color: rgba(102, 126, 234, 0.5);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
    }
    
    &.disabled {
      color: #999;
      background: #f5f5f5;
      border-color: #ddd;
      cursor: not-allowed;
      
      &:hover {
        transform: none;
        box-shadow: none;
        background: #f5f5f5;
        border-color: #ddd;
      }
    }
  }
  
  // 全额退款按钮样式
  .van-field [slot="right-icon"]:not(.verification-code-btn) {
    color: #667eea !important;
    font-weight: 500;
    padding: 0.3rem 0.8rem;
    border-radius: 1rem;
    background: rgba(102, 126, 234, 0.1);
    
    &:active {
      background: rgba(102, 126, 234, 0.2);
    }
  }
}
</style>